import moment from 'moment'

export const ERROR_FORMAT_DATE_MESSAGE = 'Date is missing or not valid'

const dateByFormat = (value, format, strict = true) => {
  if (!moment(value, format, strict).isValid()) {
    return ERROR_FORMAT_DATE_MESSAGE
  }
}

export default dateByFormat
